// extracted by mini-css-extract-plugin
module.exports = {"action-area":"_3c6ef300a5--action-area--_LcGm","action-wrapper":"_3c6ef300a5--action-wrapper--XRkjk","action-area-is-sticky":"_3c6ef300a5--action-area-is-sticky--li1lG"};